<template>
  <div class="pa-park-note-comment-editor">
    <PASimpleTextEditor
     :inputText="editorText"
     :inputImages="editorImages"
     :couldEditorExpand="editorOptions.couldEditorExpand"
     :shouldDisplayTextCounter="editorOptions.shouldDisplayTextCounter"
     :enableAttachImages="editorOptions.enableAttachImages"
     :isEditorLoading="editorOptions.isEditorLoading"
     :shouldShowInkCounter="editorOptions.shouldShowInkCounter"
     
     @changeText="handleChangeText"
     @changeImagesBlob="handleChangeImagesBlob"
    />

    <div class="button-field">
      <button
       class="button"
       :disabled="isDisabledButton"
       :class="additionalButtonClass"
       @click.prevent="handleClick"
      >投入</button>
    </div>
  </div>
</template>

<script>
import PASimpleTextEditor from '@/components/Parts/PASimpleTextEditor/PASimpleTextEditor.vue'

import TextSendWarningMixins from '@/mixins/TextSendWarningMixins.js'

import {CreateParkNoteComment} from '@/graphql/mutations/ParkNoteComment.graphql'

import {GetParkNote} from '@/graphql/queries/ParkNote.graphql'

import {GetparkProgressBar} from '@/graphql/queries/Park.graphql'

export default {
  components : {
    PASimpleTextEditor
  },

  mixins : [
    TextSendWarningMixins
  ],

  data(){
    return {
      editorText                : '',
      editorImages              : [],

      editorOptions           : {
        couldEditorExpand         : false,
        shouldDisplayTextCounter  : false,
        enableAttachImages        : true,
        isEditorLoading           : false,
        shouldShowInkCounter      : false
      },

      isLoading               : false,

      isDisabledButton        : false,

      additionalButtonClass   : {
        'is-loading'  : false
      },

      isEditorDisabled        : false,

      parkId                  : null,
    };
  },

  apollo : {
    parkNote : {
      query : GetParkNote,
      variables(){
        return {
          id : this.parkNoteId
        };
      },

      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      }
    },

    parkProgressBar : {
      query : GetparkProgressBar,
      variables(){
        return {
          park_id   : this.parkId
        };
      },
      skip(){
        if(this.parkId === null){
          return true;
        }else{
          return false;
        }
      }
    }
  },

  computed : {
    parkNoteId(){
      return this.$store.state.parkNoteComment.parkNoteId;
    }
  },

  watch : {
    isLoading : {
      handler(value){
        this.editorOptions.isEditorLoading = value;
        this.additionalButtonClass['is-loading'] = value;
      },
      immediate: true
    },

    isEditorDisabled  : {
      handler(value){
        this.editorOptions.isEditorLoading = value;
        this.isDisabledButton   = value;
      },
      immediate: true
    },

    parkNote : {
      handler(data){
        if(typeof data === 'undefined') return;

        this.parkId = data.park.id;

        if(data.accept_reply === true){
          this.isEditorDisabled = false;
        }else{
          this.isEditorDisabled = true;
        }
      },
      deep: true
    },
  },

  methods : {
    handleChangeText(value){
      this.editorText = value;
    },

    handleChangeImagesBlob(data){
      this.editorImages = data;
    },

    async handleClick(){
      this.isLoading = true;

      await this.UXWaiting(500);

      const submitBehaviour = async () => {
        this.$store.dispatch({
          type            : 'textEditorWarningModal/updateOpenModal',
          isSubmitLoading : true,
        });

        await this.UXWaiting(500);

        this.$store.dispatch({
          type            : 'textEditorWarningModal/updateOpenModal',
          value           : false,
          isSubmitLoading : false
        });

        await this.executeCreateNewComment();

        // ステータスバーを更新します。
        this.$apollo.queries.parkProgressBar.refetch();

        this.$emit('submitComment', this.editorText);

        this.isLoading = false;

        this.$nextTick(() => {
          this.checkTrurnedCommentDisabled();
        });
      };

      const cancelBehaviour = () => {
        this.$store.dispatch({
          type  : 'textEditorWarningModal/updateOpenModal',
          value : false,
        });

        this.isLoading = false;
      };

      if( this.shouldSkipWarningModal() ){
        await submitBehaviour();
      }else{
        this.$store.dispatch({
          type                  : 'textEditorWarningModal/updateOpenModal',
          value                 : true,
          handleSubmitFunction  : submitBehaviour,
          handleCancelFunction  : cancelBehaviour
        });
      }
    },

    checkTrurnedCommentDisabled(){
      if(typeof this.parkNote === 'undefined') return;

      if(typeof this.parkNote.accept_reply !== 'undefined'){
        this.isEditorDisabled = !this.parkNote.accept_reply;
      }
    },

    executeCreateNewComment(){
      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : CreateParkNoteComment,
          variables : {
            parkNoteId  : this.parkNoteId,
            body        : this.editorText,
            images      : this.editorImages
          }
        }).then(async () => {
          this.$apollo.queries.parkNote.refetch();

          await this.UXWaiting(500);
          
          this.editorText   = '';
          this.editorImages = [];
          
          resolve(true);
        }).catch(async (err) => {
          const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);

          if(typeof simpleErrorSet.firstError.field !== 'undefined'){
            const errorMessageTextSet = {
              'default'                               : "エラーが発生しました。",
              'Could not enough character ink body'   : "&nbsp;インクが足りません。",
              'This text include In-Acceptable wrod.' : "&nbsp;こちらの内容はご投稿いただくことができかねます。",
            };

            let errorMessageText = '';

            switch(simpleErrorSet.firstError.field){
              case 'body':
                if(typeof errorMessageTextSet[simpleErrorSet.firstError.message] !== 'undefined'){
                  errorMessageText = errorMessageTextSet[simpleErrorSet.firstError.message];
                }else{
                  errorMessageText = errorMessageTextSet['default'];
                }
              break;
            }

            this.$store.dispatch({
              type        : 'flashMessage/updateFlashMessage',
              hasMessage  : true,
              message     : errorMessageText,
              status      : 'error',
              hasControl  : true,
              autoClose   : 3000
            }, {root:true});
          }

          resolve(false);
        });
      });
    }
  },

  mounted(){
    this.editorOptions.shouldShowInkCounter = true;
  },
  
  beforeDestroy(){
    this.editorOptions.shouldShowInkCounter = false;
  }
}
</script>

<style lang="scss">
.pa-park-note-comment-editor{
  border-top:1px solid #c5a384;

  .pa-simple-text-editor{
    width:95%;
    margin:0 auto;
    margin-top:10px;
    border:3px solid #8A6B45;
    background-color: #DBBD98;
    border-radius: 6px;

    form.pa-form{
      min-height: 80px;
      textarea{
        min-height: 80px;
        font-size: 1rem;
        color:#515151;
      }
    }

    .meta-field{
      .attached-images{
        background-color:rgba(208, 177, 139, .4);
      }

      .controls{
        background-color:rgba(200, 200, 200, .3);
      }
    }
  }

  .button-field{
    width:95%;
    margin:10px auto 15px;

    button{
      display: block;
      margin:0 0 0 auto;
      border:0;
      background-color: #8A6B45;
      color:#DDD2C5;
      padding:0 1.5rem;
      font-size:1rem;
      height:2rem;

      &:active, &:focus, &:hover{
        color:#DDD2C5;
      }

      &:disabled{
        background-color: #8A6B45;
        color:#DDD2C5;
      }

      &.is-loading{
        background-color: #8A6B45;
        color:#DDD2C5;
      }
    }
  }
  
  form.gaogao{
    width:95%;
    margin:0 auto;
    padding-bottom:10px;

    textarea{
      box-sizing: border-box;
      margin-top:10px;
      border:3px solid #8A6B45;
      background-color: #DBBD98;
      border-radius: 6px;
      width:100%;
      height:80px;
      padding:.2rem .5rem;

      outline: -webkit-focus-ring-color auto 0;

      &:disabled{
        opacity: .8;
      }

      &.is-loading{
        opacity:.8;
      }
    }

    button{
      display: block;
      margin:0 0 0 auto;
      border:0;
      background-color: #8A6B45;
      color:#DDD2C5;
      padding:0 1.5rem;
      font-size:1rem;
      height:2rem;

      &:active, &:focus, &:hover{
        color:#DDD2C5;
      }

      &:disabled{
        background-color: #8A6B45;
        color:#DDD2C5;
      }

      &.is-loading{
        background-color: #8A6B45;
        color:#DDD2C5;
      }
    }
  }
}
</style>